export default "__VITE_ASSET__BdQ2j1jG__"